



























































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import _ from "lodash";
import moment from "moment";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() grounds!: any[];

  @Prop() stadiumId!: number;

  handleSubmit() {
    this.form.validateFields((err: any, fieldValues: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const values: any = {};
            for (const key in fieldValues) {
              if (_.get(fieldValues, [key])) {
                const fieldValue = _.get(fieldValues, [key]);
                if (moment.isMoment(fieldValue)) {
                  _.set(
                    values,
                    [key],
                    moment(fieldValue).format("YYYY-MM-DD HH:mm:ss")
                  );
                } else if (key === "block_grounds" || key === "block_weeks") {
                  _.set(values, [key], fieldValue.join(","));
                } else {
                  _.set(values, [key], fieldValue);
                }
              }
            }
            const res = await this.$store.dispatch("stadium/addBlock", {
              stadium_id: this.stadiumId,
              ...values,
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }
}
